import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import UsingAugmentColor from './UsingAugmentColor';
import ClientProvider from './client';
export default createDemo(import.meta.url, UsingAugmentColor, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/palette/demos/using-augment-color/UsingAugmentColor.tsx",
    "fileName": "UsingAugmentColor.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { createTheme, ThemeProvider } from '@mui/material/styles';\nimport Button from '@mui/material/Button';\nimport Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Typography from '@mui/material/Typography';\n\n// Augment the palette to include a salmon color\ndeclare module '@mui/material/styles' {\n  interface Palette {\n    salmon: Palette['primary'];\n  }\n\n  interface PaletteOptions {\n    salmon?: PaletteOptions['primary'];\n  }\n}\n\n// Update the Button's color options to include a salmon option\ndeclare module '@mui/material/Button' {\n  interface ButtonPropsColorOverrides {\n    salmon: true;\n  }\n}\n\nlet theme = createTheme({\n  // Theme customization goes here as usual, including tonalOffset and/or\n  // contrastThreshold as the augmentColor() function relies on these\n});\n\ntheme = createTheme(theme, {\n  // Custom colors created with augmentColor go here\n  palette: {\n    salmon: theme.palette.augmentColor({\n      color: {\n        main: '#FF5733',\n      },\n      name: 'salmon',\n    }),\n  },\n});\n\nexport default function UsingAugmentColor() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={theme}>\n      <Stack sx={{ gap: 2, alignItems: 'center' }}>\n        <Button variant=\"contained\" color=\"salmon\">\n          Salmon\n        </Button>\n        <Stack direction=\"row\" sx={{ gap: 1 }}>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">light</Typography>\n            <Box sx={{ bgcolor: 'salmon.light', width: 40, height: 20 }} />\n          </Stack>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">main</Typography>\n            <Box sx={{ bgcolor: 'salmon.main', width: 40, height: 20 }} />\n          </Stack>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">dark</Typography>\n            <Box sx={{ bgcolor: 'salmon.dark', width: 40, height: 20 }} />\n          </Stack>\n        </Stack>\n      </Stack>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 66,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { createTheme, ThemeProvider } from '@mui/material/styles';\nimport Button from '@mui/material/Button';\nimport Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Typography from '@mui/material/Typography';\n\n// Augment the palette to include a salmon color\ndeclare module '@mui/material/styles' {\n  interface Palette {\n    salmon: Palette['primary'];\n  }\n\n  interface PaletteOptions {\n    salmon?: PaletteOptions['primary'];\n  }\n}\n\n// Update the Button's color options to include a salmon option\ndeclare module '@mui/material/Button' {\n  interface ButtonPropsColorOverrides {\n    salmon: true;\n  }\n}\n\nlet theme = createTheme({\n  // Theme customization goes here as usual, including tonalOffset and/or\n  // contrastThreshold as the augmentColor() function relies on these\n});\n\ntheme = createTheme(theme, {\n  // Custom colors created with augmentColor go here\n  palette: {\n    salmon: theme.palette.augmentColor({\n      color: {\n        main: '#FF5733',\n      },\n      name: 'salmon',\n    }),\n  },\n});\n\nexport default function UsingAugmentColor() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <ThemeProvider theme={theme}>\n      <Stack sx={{ gap: 2, alignItems: 'center' }}>\n        <Button variant=\"contained\" color=\"salmon\">\n          Salmon\n        </Button>\n        <Stack direction=\"row\" sx={{ gap: 1 }}>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">light</Typography>\n            <Box sx={{ bgcolor: 'salmon.light', width: 40, height: 20 }} />\n          </Stack>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">main</Typography>\n            <Box sx={{ bgcolor: 'salmon.main', width: 40, height: 20 }} />\n          </Stack>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">dark</Typography>\n            <Box sx={{ bgcolor: 'salmon.dark', width: 40, height: 20 }} />\n          </Stack>\n        </Stack>\n      </Stack>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 66,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Button",
      "@mui/material/Box",
      "@mui/material/Stack",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
